import React from "react";
import { I18n } from "@aws-amplify/core";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import { get, map } from "lodash";

import images from "../../../assets/img/images";

const styles = {};

const TimeSlotsSettings = (props) => {
  const { editMode, formValues /*handleChange*/ } = props;

  // const addTimeSlot = () => {
  //   if (!get(formValues, ["timeSlots"])) {
  //   }
  // };

  if (editMode) {
    return (
      <Grid container direction="column" style={{ marginBottom: "40px" }}>
        <Grid item className="flexCenter" style={{ marginBottom: "12px" }}>
          <img
            src={images.plusIconColored}
            alt="plus_icon"
            style={{ cursor: "pointer", marginRight: "16px" }}
          />
          <span className="text-38 text-italic">
            {I18n.get("scheduler_timeSlotsMustNotOverlap")}
          </span>
        </Grid>
        <Grid item container>
          <Grid item xs>
            <Grid container direction="column">
              <Grid item container>
                <Grid item xs={3} className="bold-500">
                  {I18n.get("scheduler_startTime")}
                </Grid>
                <Grid item xs={3} className="bold-500">
                  {I18n.get("scheduler_endTime")}
                </Grid>
              </Grid>
              {map(get(formValues, ["timeSlots"]), (item, index) => (
                <Grid item container key={index}>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs></Grid>
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default withStyles(styles)(TimeSlotsSettings);
